import app from '@/app';

/* @ngInject */
function Icp($resource) {
	return $resource(
		'api/icps/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Icp', Icp);
